<app-configuration-page
  title="Import Instructors"
  description="Bring instructors into the studio from a spreadsheet."
  [breadcrumbs]="[{ label: 'Simple Import' }, { label: 'Import Instructors' }]">

  <app-simple-import-instructors></app-simple-import-instructors>

</app-configuration-page>
